module.exports = __webpack_public_path__ + "img/card_bg.f8cbbd75.png";